import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardText,
  CardTitle,
  Col,
  Row,
} from "reactstrap";
import NibbleInput from "../../../components/Fields/NibbleInput";
import {
  getConditionsCatalog,
  getOperativeTestsCatalog,
} from "../../../helpers/backend_helper";
import CardLoader from "../../../components/Common/CardLoader";
import * as _ from "lodash";

const OperativeTests = ({ selected = {}, validation, isReadOnly = false  }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);

    getOperativeTestsCatalog()
      .then((resp) => {
        const operativeTests = resp.map((i) => ({ ...i, checked: false }));
        const operativeTestsByKey = _.keyBy(operativeTests, "name");
        const selectedByKey = _.keyBy(selected, "name");

        const newOperativeTests = {
          ...operativeTestsByKey,
          ...selectedByKey,
        };

        validation.setFieldValue("operativeTests", newOperativeTests);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  if (isLoading)
    return (
      <CardLoader title="Cargando pruebas de operatividad con GogoTrack" />
    );

  return (
    <Card className="my-4 installation">
      <CardHeader>
        <h5 className="m-0">Pruebas de Operatividad con Plataforma</h5>
      </CardHeader>
      <CardBody>
        <Row>
          {Object.values(validation.values.operativeTests).map(
            ({ id, name }) => {
              return (
                <NibbleInput
                  key={id}
                  md={12}
                  label={name}
                  fieldName={`operativeTests.${name}.checked`}
                  fieldType="single-checkbox"
                  validation={validation}
                  readOnly={isReadOnly}
                />
              );
            }
          )}
        </Row>
      </CardBody>
    </Card>
  );
};

export default OperativeTests;
